const atualizarServicosPlano = (state, servicosPlano) => {
    state.servicosPlano = servicosPlano;
}

const atualizarServicosPlanoPeriodos = (state, servicosPlanoPeriodos) => {
    state.servicosPlanoPeriodos = servicosPlanoPeriodos;
}

const atualizarServicoPlano = (state, servicoPlano) => {
    state.servicoPlano = servicoPlano;
}

const updateServicoPlano = (state, servicoPlano) => {
    const item = state.servicosPlano.find(item => item.id === servicoPlano.id);

    Object.assign(item, servicoPlano);
}

export default {
    atualizarServicosPlano,
    atualizarServicoPlano,
    atualizarServicosPlanoPeriodos,
    updateServicoPlano
}
